import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pin = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pin icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.982C16 20.982 21 13.9526 21 8.98199C21 4.01143 16.9706 -0.0180054 12 -0.0180054C7.02944 -0.0180054 3 4.01143 3 8.98199C3 13.9526 8 20.982 12 23.982ZM12 13.982C14.7614 13.982 17 11.7434 17 8.98199C17 6.22057 14.7614 3.98199 12 3.98199C9.23858 3.98199 7 6.22057 7 8.98199C7 11.7434 9.23858 13.982 12 13.982Z"
    />
  </svg>
)
